
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Switch from "react-switch";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,


            loading: false,
            data: [],
            data_product: [],
            data_code_product: [],
            data_warehouse: [],
            data_admin: [],
            data_deposite_type: [
                { value: "buy", label: 'เบิกเพื่อขาย', },
                { value: "repair", label: 'เบิกเพื่อซ่อม', },
            ],
            decision_status: [
                { value: "approved", label: 'อนุมัติ', },
                { value: "waiting", label: 'รออนุมัติ', },
                { value: "rejected", label: 'ปฏิเสธ', },
            ],
            data_job: [],

            product_id: "",
            deposite_type: "buy",
            status: "waiting",
            warehouse_id: "",
            quantity: "",
            serial_number: "",
            item_list: [],
            data_serial_number: [],

            goods_issuance_code: "",
            ref_repaire_code: "",
            car_plate: "",
            goods_issuance_date: new Date(),
            goods_issuance_by: "",
            price_per_piece: "",
            total_price: "",
            // decision_status: false,
        }
    }
    async componentDidMount() {
        await this.GetProduct();
        await this.GetWarehouse();
        await this.GetAdmin();
        await this.GetJobAll();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
    }

    GetJobAll = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: ""
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_job: result.data.map(e => { return { value: e.job_number, label: e.job_number, job_id: e.job_id } }) });
        }
        this.setState({ loading: false });
    }
    GetById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            goods_issuance_main_id: id
        }
        let result = await GET(tokens, "v1/TH/goods-issuance-manage/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetById:", result);
            this.setState({
                goods_issuance_main_id: id,
                goods_issuance_code: result.data.goods_issuance_code,
                ref_repaire_code: result.data.ref_repaire_code ? this.state.data_job.filter(e => e.value === result.data.ref_repaire_code)[0] : "",
                goods_issuance_date: result.data.goods_issuance_date,
                car_plate: result.data.car_plate,
                deposite_type: result.data.deposite_type,
                goods_issuance_by: result.data.goods_issuance_by ? this.state.data_admin.filter(e => e.value === result.data.goods_issuance_by).length !== 0 ? this.state.data_admin.filter(e => e.value === result.data.goods_issuance_by)[0] : "" : "",
                item_list: result.data.goods_issuance_list.map(item => {
                    return {
                        product_id: {
                            value: item.all_stock_data.product_main_data.product_id,
                            label: item.all_stock_data.product_main_data.product_name,
                            unit_name: item.all_stock_data.product_main_data.unit_name,
                        },
                        product_code: {
                            value: item.all_stock_data.product_main_data.product_id,
                            label: item.all_stock_data.product_main_data.product_code,
                            unit_name: item.all_stock_data.product_main_data.unit_name,
                        },
                        warehouse_id: {
                            value: item.all_stock_data.warehouse_id,
                            label: item.all_stock_data.warehouse_name
                        },
                        quantity: item.quantity,
                        price_per_piece: item.price_per_piece,
                        total_price: item.total_price,
                        serial_number: item.serial_number,
                        data_serial_number: item.all_stock_data.serial_number
                    }
                })
            });
        }
        this.setState({ loading: false });
    }
    GetJobById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: id
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("Spare :",result.data);
            this.setState({
                item_list: result.data.product_list.filter(item => item.product_type === "อะไหล่").map(item => {
                    return {
                        product_id: item.product_id ? this.state.data_product.filter(e => e.value === item.product_id)[0] : "",
                        warehouse_id: "",
                        quantity: item.qty,
                        price_per_piece: item.price_per_piece,
                        total_price: item.total_price,
                        
                    }
                }),
            });
        }
        this.setState({ loading: false });
    }
    GetProduct = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            product_id: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data.filter(e => e.product_type === "อะไหล่"));
            this.setState({ data_product: result.data.filter(e => e.product_type === "อะไหล่").map(e => { return { 
                value: e.product_id, 
                label: e.product_name, 
                unit_name: e.unit_name,
                serial_number: e.serial_number,
                ...e
            } }),
            data_code_product: result.data.filter(e => e.product_type === "อะไหล่").map(e => { return { 
                value: e.product_id, 
                label: e.product_code, 
                unit_name: e.unit_name,
                serial_number: e.serial_number,
                ...e
            } })
        });
        }
        this.setState({ loading: false });
    }
    GetWarehouse = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: ""
        }
        let result = await GET(tokens, "v1/TH/warehouse-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            this.setState({ data_warehouse: result.data.map(e => { return { value: e.warehouse_id, label: e.warehouse_name } }) });
        }
        this.setState({ loading: false });
    }
    GetAdmin = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            user_id: ""
        }
        let result = await GET(tokens, "v1/TH/user-admin/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            this.setState({ data_admin: result.data.map(e => { return { value: e.user_id, label: e.full_name } }) });
        }
        this.setState({ loading: false });
    }

    Create = async () => {
        this.setState({ loading: true });
        let body = {
            goods_issuance_code: this.state.goods_issuance_code,
            ref_repaire_code: this.state.ref_repaire_code ? this.state.ref_repaire_code.value : "",
            goods_issuance_date: format_date(this.state.goods_issuance_date, "dd/mm/yyyy", "en"),
            goods_issuance_by: this.state.goods_issuance_by ? this.state.goods_issuance_by.value : "",
            decision_status: this.state.status === 'approved' ? 1 : 0,
            deposite_type: this.state.deposite_type,
            car_plate: this.state.car_plate,
            item_list: this.state.item_list.map(item => {
                return {
                    product_id: item.product_id.value,
                    warehouse_id: item.warehouse_id.value,
                    quantity: Number(item.quantity),
                    price_per_piece: Number(item.price_per_piece),
                    total_price: Number(item.total_price),
                    serial_number: item.serial_number
                }
            }),
        }
        let result = await POST(tokens, "v1/TH/goods-issuance-manage/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/stock/list-spare-parts");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (validate(this.state, ["category_name"])) { return };
        this.setState({ loading: true });
        let body = {
            goods_issuance_main_id: this.state.goods_issuance_main_id,
            goods_issuance_code: this.state.goods_issuance_code,
            ref_repaire_code: this.state.ref_repaire_code ? this.state.ref_repaire_code.value : "",
            goods_issuance_date: format_date(this.state.goods_issuance_date, "dd/mm/yyyy", "en"),
            goods_issuance_by: this.state.goods_issuance_by ? this.state.goods_issuance_by.value : "",
            decision_status: this.state.status === 'approved' ? 1 : 0,
            deposite_type: this.state.deposite_type,
            car_plate: this.state.car_plate,
            item_list: this.state.item_list.map(item => {
                return {
                    product_id: item.product_id.value,
                    warehouse_id: item.warehouse_id.value,
                    quantity: Number(item.quantity),
                    price_per_piece: Number(item.price_per_piece),
                    total_price: Number(item.total_price),
                    serial_number: item.serial_number
                }
            }),
        }
        let result = await PUT(tokens, "v1/TH/goods-issuance-manage/update", body);
        if (result && result.status) {
            success_url("/stock/list-spare-parts");
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>เบิกอะไหล่ {this.state.goods_issuance_code}</b></h3>
                            <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/stock/list-spare-parts" }}>
                                <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                            </button>
                        </div>
                        {/* 
                        goods_issuance_code
                        ref_repaire_code
                        goods_issuance_date
                        goods_issuance_by
                        decision_status 
                        */}
                        <div className="w-100 card border-0 p-3 rounded-lg mb-2">
                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-4">
                                    <label className="mb-2">วันที่เอกสาร:</label>
                                    <div className="w-100">
                                        <DatePicker
                                            className="form-control mb-2"
                                            placeholder="พิมพ์คำค้นหา..."
                                            onChange={(e) => {
                                                this.setState({ goods_issuance_date: e });
                                            }}
                                            value={this.state.goods_issuance_date}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-4">
                                    <label className="mb-2">ผู้เบิก:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_admin}
                                        onChange={(e) => {
                                            this.setState({ goods_issuance_by: e });
                                        }}
                                        value={this.state.goods_issuance_by}
                                        isClearable
                                    ></Select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-4">
                                    <label className="mb-2">รหัสใบแจ้งซ่อม:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_job}
                                        onChange={(e) => {
                                            this.setState({ ref_repaire_code: e });
                                            if (e) {
                                                this.GetJobById(e.job_id)
                                            }
                                        }}
                                        value={this.state.ref_repaire_code}
                                        isClearable
                                        isDisabled={true}
                                    ></Select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-4">
                                    <label className="mb-2">ประเภทการเบิก:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_deposite_type}
                                        onChange={(e) => {
                                            console.log(e.value)
                                            this.setState({ deposite_type: e.value });
                                        }}
                                        value={this.state.data_deposite_type.find(
                                            (option) => option.value === this.state.deposite_type
                                        )}
                                    ></Select>
                                </div>
                                {
                                    this.state.deposite_type === "repair" ? (
                                        <>
                                            <div className="col-12 col-md-6 col-lg-4">
                                                <label className="mb-2">ทะเบียนรถ:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder="Car Plate"
                                                    onChange={(e) => {
                                                        console.log(e.target.value)
                                                        this.setState({ car_plate: e.target.value });
                                                    }}
                                                    value={this.state.car_plate}
                                                />
                                            </div>
                                        </>
                                    ) : null
                                }
                                <div className="col-12 col-md-6 col-lg-4">
                                    <label className="mb-2">สถานะ:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.decision_status}
                                        onChange={(e) => {
                                            console.log(e.value)
                                            this.setState({ status: e.value });
                                        }}
                                        value={this.state.decision_status.find(
                                            (option) => option.value === this.state.status
                                        )}
                                    ></Select>
                                </div>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0 rounded-lg mb-2" style={{ height: "100%" }}>
                            <div>
                                <table className="table table-borderless table-striped" style={{ marginBottom: 200 }}>
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white wpx-70">ลำดับ</th>
                                            <th className="text-left text-white">รหัสสินค้า</th>
                                            <th className="text-left text-white">ชื่อสินค้า</th>
                                            <th className="text-left text-white">เลข serial number</th>
                                            <th className="text-left text-white ">คลัง</th>
                                            <th className="text-end text-white wpx-100">จำนวน</th>
                                            <th className="text-left text-white wpx-100">หน่วยนับ</th>
                                            <th className="text-end text-white wpx-120">ราคาขาย/หน่วย</th>
                                            <th className="text-end text-white wpx-100">ราคารวม</th>
                                            <th className="text-center text-white wpx-70">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.item_list && this.state.item_list.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{index + 1}</td>
                                                <td className="text-left">
                                                    <Select
                                                        className="form-control select-search"
                                                        styles={select_style}
                                                        options={this.state.data_code_product}
                                                        onChange={(e) => {
                                                            let item_list = this.state.item_list;
                                                            const item = {...e}
                                                            if (e) {
                                                                delete item['value']
                                                                delete item['label']
                                                                item_list[index].product_code = { value: item.product_code, label: item.product_code, ...item }
                                                                item_list[index].product_id = { value: item.product_id, label: item.product_name, ...item }
                                                                item_list[index].unit_name = e.unit_name;
                                                            } else {
                                                                item_list[index].product_id = "";
                                                                item_list[index].product_id = "";
                                                                item_list[index].unit_name = "";
                                                            }
                                                            this.setState({ item_list: item_list });
                                                        }}
                                                        value={item.product_code}
                                                        isClearable
                                                    ></Select>
                                                </td>
                                                <td className="text-left">
                                                    <Select
                                                        className="form-control select-search"
                                                        styles={select_style}
                                                        options={this.state.data_product}
                                                        onChange={(e) => {
                                                            let item_list = this.state.item_list;
                                                            if (e) {
                                                                const item = {...e}
                                                                delete item['value']
                                                                delete item['label']
                                                                item_list[index].product_code = { value: item.product_code, label: item.product_code, ...item }
                                                                item_list[index].product_id = { value: item.product_id, label: item.product_name, ...item }
                                                                item_list[index].unit_name = e.unit_name;
                                                            } else {
                                                                item_list[index].product_id = "";
                                                                item_list[index].unit_name = "";
                                                            }
                                                            this.setState({ item_list: item_list });
                                                        }}
                                                        value={item.product_id}
                                                        isClearable
                                                    ></Select>
                                                </td>
                                                <td className="text-left">
                                                    <Select
                                                        className="form-control select-search"
                                                        styles={select_style}
                                                        options={this.state.item_list[index].data_serial_number.map((value) => { return { value: value, label: value } }) }
                                                        onChange={(e) => {
                                                            let item_list = this.state.item_list;
                                                            console.log('Selected Serial Number:', e ? e.value : "None");
                                                            if (e) {
                                                                item_list[index].serial_number = e.value
                                                            } else {
                                                                item_list[index].serial_number = "";
                                                            }
                                                            this.setState({ item_list: item_list });
                                                        }}
                                                        value={
                                                            this.state.item_list[index].serial_number ?
                                                            { 
                                                                value: this.state.item_list[index].serial_number,
                                                                label: this.state.item_list[index].serial_number 
                                                            } : null
                                                        }
                                                        isDisabled={this.state.item_list[index].data_serial_number ? this.state.item_list[index].data_serial_number.length <= 0 : false}
                                                    ></Select>
                                                </td>
                                                <td className="text-left">
                                                    <Select
                                                        className="form-control select-search"
                                                        styles={select_style}
                                                        options={this.state.data_warehouse}
                                                        onChange={(e) => {
                                                            let item_list = this.state.item_list;
                                                            if (e) {
                                                                item_list[index].warehouse_id = e
                                                            } else {
                                                                item_list[index].warehouse_id = "";
                                                            }
                                                            this.setState({ item_list: item_list });
                                                        }}
                                                        value={item.warehouse_id}
                                                        isClearable
                                                    ></Select>
                                                </td>
                                                <td className="text-end">
                                                    <input
                                                        className="form-control text-end"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            if (!float(e.target.value)) {
                                                                return
                                                            }
                                                            let item_list = this.state.item_list;
                                                            item_list[index].quantity = e.target.value
                                                            item_list[index].total_price = e.target.value * item_list[index].price_per_piece
                                                            this.setState({ item_list: item_list });
                                                        }}
                                                        value={item.quantity}
                                                    />
                                                </td>
                                                <td className="text-left">{item.product_id ? item.product_id.unit_name : "-"}</td>
                                                <td className="text-end">
                                                    <input
                                                        className="form-control text-end"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                            if (!float(e.target.value)) {
                                                                return
                                                            }
                                                            let item_list = this.state.item_list;
                                                            item_list[index].price_per_piece = e.target.value
                                                            item_list[index].total_price = e.target.value * item_list[index].quantity
                                                            this.setState({ item_list: item_list });
                                                        }}
                                                        value={item.price_per_piece}
                                                    />
                                                </td>
                                                <td className="text-end">
                                                    {item.total_price ? (parseFloat(item.total_price).toFixed(2)) : "-"}
                                                </td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => {
                                                                let item_list = this.state.item_list;
                                                                item_list.splice(index, 1);
                                                                this.setState({ item_list: item_list });
                                                            }}>
                                                            <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td className="text-center">
                                                -
                                            </td>
                                            <td className="text-left">
                                                <Select
                                                    className="form-control select-search"
                                                    styles={select_style}
                                                    options={this.state.data_code_product}
                                                    onChange={(e) => {
                                                        console.log('e :',e)
                                                        const item = {...e}
                                                        delete item['value']
                                                        delete item['label']
                                                        if(e){
                                                            this.setState({ 
                                                                product_code: { value: item.product_code, label: item.product_code, ...item },
                                                                product_id: { value: item.product_id, label: item.product_name, ...item },
                                                                unit_name: e.unit_name,
                                                                data_serial_number: e.serial_number,
                                                                serial_number: ''
                                                            });
                                                        } else {
                                                            this.setState({ 
                                                                product_id: null, 
                                                                product_name: null,
                                                                unit_name: '',
                                                                data_serial_number: [],
                                                                serial_number: ''
                                                            });
                                                        }
                                                    }}
                                                    value={this.state.product_code}
                                                    isClearable
                                                ></Select>
                                            </td>
                                            <td className="text-left">
                                                <Select
                                                    className="form-control select-search"
                                                    styles={select_style}
                                                    options={this.state.data_product}
                                                    onChange={(e) => {
                                                        console.log('e :',e)
                                                        const item = {...e}
                                                        delete item['value']
                                                        delete item['label']
                                                        if(e){
                                                            this.setState({ 
                                                                product_code: { value: item.product_code, label: item.product_code, ...item },
                                                                product_id: { value: item.product_id, label: item.product_name, ...item },
                                                                unit_name: e.unit_name,
                                                                data_serial_number: e.serial_number,
                                                                serial_number: ''
                                                            });
                                                        } else {
                                                            this.setState({ 
                                                                product_id: null, 
                                                                product_name: null,
                                                                unit_name: '',
                                                                data_serial_number: [],
                                                                serial_number: ''
                                                            });
                                                        }
                                                    }}
                                                    value={this.state.product_id}
                                                    isClearable
                                                ></Select>
                                            </td>
                                            <td className="text-left">
                                                <Select
                                                    className="form-control select-search"
                                                    styles={select_style}
                                                    options={this.state.data_serial_number.map((value) => { return { value: value, label: value } })}
                                                    onChange={(e) => {
                                                        this.setState({ serial_number: e ? e.value : "" });
                                                    }}
                                                    value={this.state.serial_number ? { value: this.state.serial_number, label: this.state.serial_number } : null}
                                                    isClearable
                                                    isDisabled={this.state.data_serial_number.length <= 0}
                                                ></Select>
                                            </td>
                                            <td className="text-left">
                                                <Select
                                                    className="form-control select-search"
                                                    styles={select_style}
                                                    options={this.state.data_warehouse}
                                                    onChange={(e) => {
                                                        this.setState({ warehouse_id: e });
                                                    }}
                                                    value={this.state.warehouse_id}
                                                    isClearable
                                                ></Select>
                                            </td>
                                            <td className="text-end">
                                                <input
                                                    className="form-control text-end"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) {
                                                            return
                                                        }
                                                        this.setState({ total_price: e.target.value * this.state.price_per_piece })
                                                        this.setState({ quantity: e.target.value })
                                                    }}
                                                    value={this.state.quantity}
                                                />
                                            </td>
                                            <td className="text-left">
                                                <span>{this.state.unit_name ? this.state.unit_name : "-"}</span>
                                            </td>
                                            <td className="text-left">
                                                <input
                                                    className="form-control text-end"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) {
                                                            return
                                                        }
                                                        this.setState({ total_price: e.target.value * this.state.quantity })
                                                        this.setState({ price_per_piece: e.target.value })
                                                    }}
                                                        value={this.state.price_per_piece}
                                                    />                                            </td>
                                                
                                                <td className="text-end">
                                                    <span>{this.state.total_price ? (parseFloat(this.state.total_price).toFixed(2)) : "-"}</span>
                                                </td>
                                                <td className="text-center">
                                                <div className="w-100 d-flex justify-content-center">
                                                    <div className="wpx-30 hpx-30 rounded-circle bg-blue text-24 text-white d-flex justify-content-center align-items-center pointer"
                                                        onClick={() => {
                                                            if (!this.state.product_id) {
                                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                                return;
                                                            } else if (!this.state.warehouse_id) {
                                                                alert("warning", "แจ้งเตือน", "กรุณาเลือกโกดัง");
                                                                return;
                                                            } else if (!this.state.quantity) {
                                                                alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                                                return;
                                                            }
                                                            let item_list = this.state.item_list;
                                                            item_list.push({
                                                                product_code: this.state.product_code,
                                                                product_id: this.state.product_id,
                                                                warehouse_id: this.state.warehouse_id,
                                                                quantity: this.state.quantity,
                                                                serial_number: this.state.serial_number,
                                                                price_per_piece: this.state.price_per_piece,
                                                                data_serial_number: this.state.data_serial_number,
                                                                total_price: this.state.total_price
                                                            })
                                                            this.setState({
                                                                item_list: item_list,
                                                                product_id: "",
                                                                product_code: "",
                                                                warehouse_id: "",
                                                                quantity: "",
                                                                serial_number: "",
                                                                price_per_piece: "",
                                                                total_price: "",
                                                            })
                                                        }}>+</div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body w-100 position-fixed bg-white p-3 d-flex align-items-center justify-content-end" style={{ bottom: 0 }}>
                    {/* <label className="mx-1">ยืนยันการเบิก</label>
                    <input type="checkbox" className="mx-1" onChange={() => { this.setState({ decision_status: !this.state.decision_status }) }} checked={this.state.decision_status} /> */}
                    <button className="btn btn-outline-orange mx-1" onClick={() => { this.setState({ modal_sub_pay: true }) }}>
                        ยกเลิก
                    </button>
                    <button className="btn btn-orange mx-1" onClick={() => {
                        if (!this.state.goods_issuance_date) {
                            alert("warning", "แจ้งเตือน", "กรุณาเลือกวันที่เอกสาร");
                            return;
                        } else if (!this.state.goods_issuance_by) {
                            alert("warning", "แจ้งเตือน", "กรุณาเลือกผู้เบิก");
                            return;
                        } else if (this.state.item_list.length === 0) {
                            alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                            return;
                        } else if (this.state.item_list.filter(e => !e.warehouse_id).length !== 0) {
                            alert("warning", "แจ้งเตือน", "กรุณาเลือกคลัง");
                            return;
                        }
                        // else if (!this.state.ref_repaire_code) {
                        //     alert("warning", "แจ้งเตือน", "กรุณาเลือกใบแจ้งซ่อม");
                        //     return;
                        // }

                        if (this.props.location.query.id) {
                            this.Update()
                        } else {
                            this.Create()
                        }
                    }}>
                        บันทึก
                    </button>
                </div>
                {/* create update */}
                <Modal show={this.state.modal_create || this.state.modal_update}
                    onHide={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                    <Modal.Header><Modal.Title><b>{this.state.modal_create ? "เพิ่มหมวดหมู่" : "แก้ไขหมวดหมู่"}</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* ชื่อหมวดหมู่สินค้า */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ชื่อหมวดหมู่สินค้า:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => { this.setState({ branch_name: e.target.value }) }}
                                value={this.state.branch_name}
                            />
                        </div>
                        {/* รายละเอียด */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">รายละเอียด:</label>
                            <textarea
                                className="form-control"
                                placeholder=""
                                onChange={(e) => {
                                    this.setState({ phone_number: e.target.value })
                                }}
                                value={this.state.phone_number}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.modal_create) {
                                            this.Create();
                                        } else {
                                            this.Update();
                                        }
                                    }}>
                                    {this.state.modal_create ? "เพิ่ม" : "บันทึก"}
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
